import {JsonProperty} from '@hyperloris/tyson';
import {FieldRecord} from "../api/field-record";
import {FieldResult} from "../api/field-result";
import {ReportProfile} from "./report-profile";

export class ProfileFieldResult extends FieldResult<ReportProfile> {

  @JsonProperty()
  recordTypes: FieldRecord<any>[];

}

